<template>
  <div id="app">
   

  
  <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
 
}
</script>

<style>
@import './assets/css/global.css'; /*引入公共样式*/

</style>
